// Actions
export const DISPLAY_SNACKBAR = 'DISPLAY_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

// Reducer
interface SnackbarAction {
  type: string;
  message?: string;
  bg?: 'danger' | 'success' | 'info';
  autoHide?: boolean;
  html?: boolean;
  values?: Record<string, any>; // Add `values` as optional
}

export interface SnackbarReducerState {
  open: boolean;
  message: string;
  bg: 'danger' | 'success' | 'info' | 'none';
  autoHide?: boolean;
  html?: boolean;
  values?: Record<string, any>;
}

const initialState: SnackbarReducerState = {
  open: false,
  message: '',
  bg: 'info',
  autoHide: true,
  values: undefined,
};

export const snackbarReducer = (
    state: SnackbarReducerState = initialState,
    action: SnackbarAction
): SnackbarReducerState => {
  switch (action.type) {
    case DISPLAY_SNACKBAR:
      return {
        ...state,
        message: action.message!,
        open: true,
        bg: action.bg ? action.bg : 'info',
        autoHide: action.autoHide,
        html: action.html,
        values: action.values,
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        message: '',
        open: false,
        bg: 'none',
        values: undefined,
      };
    default:
      return state;
  }
};

// Action Creators
export interface DisplaySnackbar {
  (
      message: string,
      bg?: 'danger' | 'success' | 'info',
      autoHide?: boolean,
      html?: boolean,
      values?: Record<string, any>
  ): (dispatch: Function) => void;
}

export const displaySnackbar: DisplaySnackbar = (
    message,
    bg,
    autoHide,
    html = true,
    values
) => {
  return (dispatch: Function) => {
    setTimeout(() => {
      dispatch({ message, bg, autoHide, html, values, type: DISPLAY_SNACKBAR });
    }, 100);
  };
};


export interface HideSnackbar {
  (): (dispatch: Function) => void;
}

export const hideSnackbar: HideSnackbar = () => {
  return (dispatch: Function) => {
    dispatch({ type: HIDE_SNACKBAR });
  };
};
